import { BaseRuntime } from './BaseRuntime';

const READ_ONLY = {
  'cmi.core.student_id': true,
  'cmi.core.student_name': true,
  'cmi.core.credit': true,
  'cmi.core.entry': true,
  'cmi.core.total_time': true,
  'cmi.core.lesson_mode': true,
  'cmi.launch_data': true,
  'cmi.comments_from_lms': true,
};

export class Scorm12Runtime extends BaseRuntime {
  constructor(opts) {
    super({ ...opts, version: '1.2' });
    this.set('cmi.core.lesson_status', 'not attempted');
    this.set('cmi.core.lesson_location', '');
    this.set('cmi.core.score.raw', '');
    this.set('cmi.core.score.min', '0');
    this.set('cmi.core.score.max', '100');
    this.set('cmi.suspend_data', '');
    this.set('cmi.core.exit', '');
    this.set('cmi.core.session_time', '0000:00:00');
  }

  LMSInitialize() {
    return this.beginCommunication();
  }

  LMSFinish() {
    return this.finish();
  }

  LMSGetValue(key) {
    return this.get(key);
  }

  LMSSetValue(key, value) {
    if (READ_ONLY[key]) return 'false';
    return this.set(key, value);
  }

  LMSCommit() {
    return this.commit();
  }

  LMSGetLastError() {
    return this.errorCode;
  }

  LMSGetErrorString() {
    return '';
  }

  LMSGetDiagnostic() {
    return '';
  }
}

export function build12Adapter(runtime) {
  return {
    LMSInitialize: () => runtime.LMSInitialize(),
    LMSFinish: () => runtime.LMSFinish(),
    LMSGetValue: (k) => runtime.LMSGetValue(k),
    LMSSetValue: (k, v) => runtime.LMSSetValue(k, v),
    LMSCommit: () => runtime.LMSCommit(),
    LMSGetLastError: () => runtime.LMSGetLastError(),
    LMSGetErrorString: (c) => runtime.LMSGetErrorString(c),
    LMSGetDiagnostic: (c) => runtime.LMSGetDiagnostic(c),
  };
}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/scorm/frontend/runtime/Scorm12Runtime.js